/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Redirecting_DescriptionInputs */

const en_auth_redirecting_description = /** @type {(inputs: Auth_Redirecting_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking you to the login page. This should only take a moment.`)
};

const pt_br2_auth_redirecting_description = /** @type {(inputs: Auth_Redirecting_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levando você à página de login. Isso deve levar apenas um momento.`)
};

/**
* | output |
* | --- |
* | "Taking you to the login page. This should only take a moment." |
*
* @param {Auth_Redirecting_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_redirecting_description = /** @type {((inputs?: Auth_Redirecting_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Redirecting_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_redirecting_description(inputs)
	return pt_br2_auth_redirecting_description(inputs)
});